import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8b5676ea"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "invite-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务中心", -1));
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 规则 ");
const _hoisted_4 = {
  key: 1,
  style: {
    "height": "15px"
  }
};
const _hoisted_5 = {
  class: "content"
};
const _hoisted_6 = {
  class: "top_info_box"
};
const _hoisted_7 = /*#__PURE__*/_createTextVNode("我的金币");
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon"
}, null, -1));
const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = {
  class: "score_txt"
};
const _hoisted_11 = {
  key: 0,
  class: "score_tips"
};
const _hoisted_12 = {
  key: 0,
  class: "gold-num-des"
};
const _hoisted_13 = {
  key: 1,
  class: "expired-wrapper"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "task_content_inner"
};
const _hoisted_16 = {
  key: 0,
  class: "task_normal_title"
};
const _hoisted_17 = {
  key: 1,
  class: "activity_time_banner"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, [/*#__PURE__*/_createElementVNode("p", null, "活动时间"), /*#__PURE__*/_createElementVNode("p", null, "2026.03.18-2026.06.17")], -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, [/*#__PURE__*/_createElementVNode("p", null, "活动金币有效期"), /*#__PURE__*/_createElementVNode("p", null, "领取后90天")], -1));
const _hoisted_20 = [_hoisted_18, _hoisted_19];
const _hoisted_21 = {
  key: 2,
  class: "activity_list"
};
const _hoisted_22 = {
  class: "activity_prize"
};
const _hoisted_23 = {
  class: "prize"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "活动期间，每人限领1次", -1));
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  class: "label"
};
const _hoisted_27 = {
  class: "activity_prize"
};
const _hoisted_28 = {
  class: "prize"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = {
  key: 2,
  class: "activity_pro_step"
};
const _hoisted_31 = {
  class: "activity_prize"
};
const _hoisted_32 = {
  class: "prize"
};
const _hoisted_33 = {
  key: 3,
  class: "activity_score_enter"
};
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-8b5676ea>摩点官方抽奖</div><div class=\"score_status\" data-v-8b5676ea><p class=\"txt\" data-v-8b5676ea>审核通过</p><div class=\"border_right\" data-v-8b5676ea></div></div><div class=\"col_three\" data-v-8b5676ea><div class=\"item\" data-v-8b5676ea><p class=\"title\" data-v-8b5676ea>权益一</p><p data-v-8b5676ea>首页icon资源，每日曝光约50w</p></div><div class=\"item\" data-v-8b5676ea><p class=\"title\" data-v-8b5676ea>权益二</p><p data-v-8b5676ea>最高得1.5w金币（货值*10倍）</p></div><div class=\"item\" data-v-8b5676ea><p class=\"title\" data-v-8b5676ea>权益一</p><p data-v-8b5676ea>用户任务优先展示（浏览、种草）</p></div></div>", 3);
const _hoisted_37 = [_hoisted_34];
const _hoisted_38 = {
  key: 4,
  class: "max_prize"
};
const _hoisted_39 = {
  key: 0,
  class: "max_prize_txt"
};
const _hoisted_40 = /*#__PURE__*/_createTextVNode("最高可得");
const _hoisted_41 = {
  class: "max_prize_num"
};
const _hoisted_42 = /*#__PURE__*/_createTextVNode("金币；活动期间开售的项目，进度达100%且筹资≥10000；*文玩项目不参与活动");
const _hoisted_43 = {
  key: 1,
  class: "max_prize_txt"
};
const _hoisted_44 = /*#__PURE__*/_createTextVNode("最高可得");
const _hoisted_45 = {
  class: "max_prize_num"
};
const _hoisted_46 = /*#__PURE__*/_createTextVNode("金币，仅限众筹预热/众筹中项目，每项目限领1次");
const _hoisted_47 = {
  key: 2,
  class: "max_prize_txt_des"
};
const _hoisted_48 = /*#__PURE__*/_createTextVNode("最高可得");
const _hoisted_49 = {
  class: "max_prize_num"
};
const _hoisted_50 = /*#__PURE__*/_createTextVNode("金币，活动期间，每人限领1次");
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "activity_item_top"
}, null, -1));
const _hoisted_52 = ["onClick"];
const _hoisted_53 = ["onClick"];
const _hoisted_54 = {
  key: 0,
  class: "activity_list"
};
const _hoisted_55 = {
  class: "activity_item newbie_list"
};
const _hoisted_56 = {
  class: "label"
};
const _hoisted_57 = {
  class: "activity_prize"
};
const _hoisted_58 = {
  class: "prize"
};
const _hoisted_59 = ["onClick"];
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "max_prize"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "max_prize_txt_des"
}, "新手任务奖励每人限领1次")], -1));
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "activity_item_top"
}, null, -1));
const _hoisted_62 = {
  key: 1,
  class: "activity_list"
};
const _hoisted_63 = {
  class: "activity_item week_list"
};
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "max_prize week"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "max_prize_txt_des"
}, [/*#__PURE__*/_createTextVNode("每周一更新任务，每个项目全部任务完成会奖励"), /*#__PURE__*/_createElementVNode("span", {
  class: "max_prize_num"
}, "500"), /*#__PURE__*/_createTextVNode("金币")])], -1));
const _hoisted_65 = {
  class: "week_title"
};
const _hoisted_66 = {
  class: "label"
};
const _hoisted_67 = {
  class: "activity_prize"
};
const _hoisted_68 = {
  class: "num"
};
const _hoisted_69 = {
  class: "prize"
};
const _hoisted_70 = ["onClick"];
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "activity_item_top"
}, null, -1));
const _hoisted_72 = {
  key: 2,
  class: "activity_list"
};
const _hoisted_73 = {
  class: "activity_item goal_list"
};
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "max_prize"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "max_prize_txt"
}, "若达到目标筹资金额最高奖励1000金币，另筹资金额每达阶梯后会额外赠送金币")], -1));
const _hoisted_75 = {
  class: "top_title"
};
const _hoisted_76 = {
  class: "title"
};
const _hoisted_77 = {
  class: "goal_items"
};
const _hoisted_78 = {
  key: 0,
  class: "next_prize_item"
};
const _hoisted_79 = {
  class: "money"
};
const _hoisted_80 = /*#__PURE__*/_createTextVNode("冲击金额 ");
const _hoisted_81 = {
  class: "prize"
};
const _hoisted_82 = /*#__PURE__*/_createTextVNode("将获得");
const _hoisted_83 = {
  class: "goal_content"
};
const _hoisted_84 = {
  class: "done_top"
};
const _hoisted_85 = {
  class: "num"
};
const _hoisted_86 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "筹资金额", -1));
const _hoisted_87 = {
  class: "activity_prize"
};
const _hoisted_88 = {
  class: "prize"
};
const _hoisted_89 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "color": "#7F7F7F"
  }
}, "共奖励", -1));
const _hoisted_90 = {
  class: "done_bottom"
};
const _hoisted_91 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "activity_item_top"
}, null, -1));
import { env } from "md-base-tools/env";
import domain from "@/service/domain";
import router from '@/router';
import { reactive, onMounted, onBeforeUnmount, ref } from "vue";
import { getSchemeUrl } from "@/utils/toolsApi";
import { getTaskList, getActivityTaskList, receiveTaskGold, getGoldNum, videoStyduSuccess } from "@/api";
import { CopyContent, GoBack, mdAlert, mdToast, QuickCopy } from "../../utils/tools";
import MDRouter from "../../service/router";
import updateGuide from "../../components/task/update_guide.vue";
import redNoteUpdateGuide from "../../components/task/red_note_update_guide.vue";
import threeChoseOne from "../../components/task/three_chose_one.vue";
export default {
  setup(__props) {
    const isFix = ref(0);
    const state = reactive({
      showActivityList: true,
      showThreeChoseOne: false
    });
    // 每周任务
    const week_task_list = ref([]);
    // 筹资金额
    const goal_task_list = ref([]);
    // 新手任务
    const newbie_task_list = ref([]);
    const statusBarH = ref(0);
    onMounted(() => {
      document.title = '任务中心';

      // 请求金币余额
      requestGoldInfo();
      // 请求任务周任务列表及即有项目列表
      requestTaskList();
      // 请求限时活动列表
      requestActivityTaskList();

      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "onGetDeviceInfo",
        functionParams: {},
        callBack: e => {
          console.log('statusBarH---------', e.data.statusBarH);
          statusBarH.value = Number(e.data.statusBarH);
        }
      });
    });
    onBeforeUnmount(() => {
      // 清理定时器
      if (expiredTimer) {
        clearInterval(expiredTimer);
        expiredTimer = null;
      }
    });
    async function requestTaskList() {
      const {
        status,
        data,
        message
      } = await getTaskList();
      if (status == 0) {
        week_task_list.value = data.week_task_list || [];
        goal_task_list.value = data.goal_task_list || [];
        newbie_task_list.value = data.newbie_task_list || [];
      } else {
        mdToast(message);
      }
    }
    // 限时活动任务
    const activity_task_list = ref([]);
    async function requestActivityTaskList() {
      const {
        status,
        data
      } = await getActivityTaskList();
      if (status == 0) {
        activity_task_list.value = data.list ? processActivityTaskList(data.list) : [];
      }
    }
    // 判断是否显示步骤图标
    const shouldShowStepIcon = (taskList, currentIndex) => {
      // 找到第一个未完成任务的索引
      const firstIncompleteIndex = taskList.findIndex(task => task.task_status == 0);

      // 如果没有未完成的任务，显示所有图标
      if (firstIncompleteIndex === -1) {
        return true;
      }

      // 只显示到第一个未完成任务为止（包括第一个未完成任务）
      return currentIndex <= firstIncompleteIndex;
    };
    // 获取步骤状态类名
    const getStepStatusClass = (task, taskList, currentIndex) => {
      // 如果已完成
      if (task.task_status == 20) {
        return 'completed';
      }
      // 如果应该显示（进行中）
      if (shouldShowStepIcon(taskList, currentIndex)) {
        return 'pregoing';
      }
      // 未到达
      return 'unarrived';
    };
    // 处理活动任务列表，按照task_id分组
    const processActivityTaskList = list => {
      // 定义分组规则
      const groupConfig = [{
        task_name: '商家回归礼',
        task_type: 3,
        task_ids: [56],
        task_list: []
      }, {
        task_name: '众筹发布礼',
        task_type: 1,
        task_ids: [25, 26, 57],
        task_list: []
      }, {
        task_name: '项目运营礼',
        task_type: 2,
        task_ids: [58, 59, 60, 64],
        task_list: []
      }, {
        task_name: '筹资达标礼',
        task_type: 4,
        task_ids: [61, 62, 63],
        task_list: []
      }];

      // 将任务分配到对应的组
      list.forEach(task => {
        groupConfig.forEach(group => {
          if (group.task_ids.includes(task.task_id)) {
            group.task_list.push(task);
          }
        });
      });

      // 计算每组的最高金币数并过滤掉空组
      const result = groupConfig.filter(group => group.task_list.length > 0).map(group => {
        const max_prize = group.task_list.reduce((sum, task) => sum + task.prize, 0);
        return {
          task_name: group.task_name,
          task_type: group.task_type,
          max_prize: max_prize,
          task_list: group.task_list
        };
      });

      // 写死的活动：在"众筹发布礼"后面插入（索引1之后）
      const customActivity = {
        task_name: '摩点官方抽奖',
        task_type: 5,
        max_prize: 15000,
        task_ids: [999],
        task_list: []
      };

      // 找到"众筹发布礼"的索引并在其后插入
      const publishIndex = result.findIndex(item => item.task_name === '众筹发布礼');
      if (publishIndex !== -1) {
        result.splice(publishIndex + 1, 0, customActivity);
      } else {
        // 如果没找到"众筹发布礼"，则插入到开头
        result.unshift(customActivity);
      }
      return result;
    };
    const goldNum = ref('');
    const activityGoldNum = ref('');
    const expiredActivityGoldNum = ref('');
    const activity_coin_balance_expired_date = ref([]);
    const currentExpiredIndex = ref(0);
    let expiredTimer = null;
    async function requestGoldInfo() {
      const {
        status,
        data
      } = await getGoldNum();
      if (status == 0) {
        goldNum.value = data.balance;
        activityGoldNum.value = data.activity_coin_balance;
        expiredActivityGoldNum.value = data.activity_coin_balance_expired;
        activity_coin_balance_expired_date.value = data.activity_coin_balance_expired_date || [];

        // 启动轮播
        if (activity_coin_balance_expired_date.value.length > 1) {
          startExpiredCarousel();
        }
      }
    }

    // 启动轮播功能
    const startExpiredCarousel = () => {
      // 清除已存在的定时器
      if (expiredTimer) {
        clearInterval(expiredTimer);
      }
      // 每3秒切换一次
      expiredTimer = setInterval(() => {
        currentExpiredIndex.value = (currentExpiredIndex.value + 1) % activity_coin_balance_expired_date.value.length;
      }, 3000);
    };
    const showUpdateGuide = ref(false);
    const showUpdateProID = ref('');
    const showUpdateTaskID = ref('');
    const showRedNoteUpdateGuide = ref(false);
    const showMerchantReceiveSuccess = ref(false);

    // 点击周任务按钮
    async function handleTaskAction(event, pro_id, item) {
      // task_status -1 待开启 0进行中 10已完成 20已领取
      if (item.task_status == 10) {
        // 领取
        const {
          status,
          message
        } = await receiveTaskGold({
          task_id: item.task_id,
          pro_id: pro_id
        });
        if (status == 0) {
          //请求列表
          if (item.task_id == 31) {
            showMerchantReceiveSuccess.value = true;
          } else {
            mdToast('领取成功');
          }
          requestActivityTaskList();
          requestTaskList();
          // 重新获取金币信息，更新轮播数据
          requestGoldInfo();
        } else {
          mdToast(message);
        }
      } else if (item.task_status == 0) {
        // 去完成
        //任务ID 1创意转众筹 2分享 3回复 4发布更新 5抽奖功能教学 6短信推广功能教学 7常见问题功能教学 8批量发货教学 9更换项目封面图 20发布更新（结束未交付）23专属感恩礼 24邀请新发起人 25发布创意上线 26众筹项目提交审核 27众筹项目上线
        switch (item.task_id) {
          case 1:
            {
              //1创意转众筹-说明：是否有创建的创意，若有点击后跳转至创意列表；若无点击后去创建创意
              if (item.is_have_idea) {
                // 有创意-跳转发布的创意列表
                // eslint-disable-next-line no-undef
                graft.app({
                  functionName: "openController",
                  functionParams: `md://createIdeaList`,
                  webFun: () => {
                    mdToast('功能暂不支持');
                  }
                });
              } else {
                // 无创意-跳转创建创意
                // eslint-disable-next-line no-undef
                graft.app({
                  functionName: "openController",
                  functionParams: `md://publishIdea`,
                  webFun: () => {
                    router.push({
                      path: `/idea/create`
                    });
                  }
                });
              }
            }
            break;
          case 2:
            {
              //分享-弹窗
              // eslint-disable-next-line no-undef
              graft.app({
                functionName: "openController",
                functionParams: `${domain.wap}/score/task/share_guide?pro_id=${pro_id}`,
                webFun: () => {
                  router.push({
                    path: `/score/task/share_guide`,
                    query: {
                      'pro_id': pro_id
                    }
                  });
                }
              });
            }
            break;
          case 3:
            {
              //回复-详情
              MDRouter.goProInfo(pro_id);
            }
            break;
          case 4:
          case 20:
            {
              //发布更新-弹窗 4
              //发布更新（结束未交付-弹窗 20

              showUpdateProID.value = pro_id;
              showUpdateTaskID.value = item.task_id;
              showUpdateGuide.value = true;
            }
            break;
          case 5:
          case 6:
          case 7:
          case 8:
            {
              //抽奖功能教学/短信推广功能教学/常见问题功能教学/批量发货教学
              // eslint-disable-next-line no-undef
              router.push({
                path: `/score/task/video_guide`,
                query: {
                  'video_url': item.video_url,
                  'task_id': item.task_id,
                  'pro_id': pro_id
                }
              });
            }
            break;
          case 9:
            {
              //更换项目封面图-弹窗

              mdAlert({
                title: '提示',
                content: '请复制链接在电脑端打开，可在「编辑项目」中更新项目封面图',
                actions: ['复制链接'],
                _callback: () => {
                  QuickCopy(`https://member.modian.com/project_manage/index/${pro_id}.html`);
                }
              });
            }
            break;
          case 23:
            {
              //专属感恩礼
            }
            break;
          case 24:
          case 35:
          case 36:
            {
              //邀请新发起人 OK

              // eslint-disable-next-line no-undef
              graft.app({
                functionName: "openController",
                functionParams: `${domain.wap}/mdactivity/fastsell/recommend`,
                webFun: () => {
                  if (env.isWxApp()) {
                    // eslint-disable-next-line no-undef
                    wx.miniProgram.navigateTo({
                      url: '/pages/activePages/recommmend/recommmend'
                    });
                  } else {
                    router.push({
                      path: `/mdactivity/fastsell/recommend`
                    });
                  }
                }
              });
            }
            break;
          case 25:
          case 50:
          case 32:
            {
              //发布创意上线 OK

              // eslint-disable-next-line no-undef
              graft.app({
                functionName: "openController",
                functionParams: `md://publishIdea`,
                webFun: () => {
                  if (env.isMobile()) {
                    router.push({
                      path: `/idea/create`
                    });
                  } else {
                    window.location.href = 'https://account.modian.com/initiate/category';
                  }
                }
              });
            }
            break;
          case 26:
          case 33:
            {
              //众筹项目提交审核-PC-CP后台；其他端-发布众筹页

              // eslint-disable-next-line no-undef
              graft.app({
                functionName: "openController",
                functionParams: `md://create_project`,
                webFun: () => {
                  if (env.isWxApp()) {
                    // eslint-disable-next-line no-undef
                    wx.miniProgram.navigateTo({
                      url: '/pages/projectPages/project-initiate/project-initiate'
                    });
                  } else {
                    window.location.href = 'https://account.modian.com/m/initiate';
                  }
                }
              });
            }
            break;
          case 27:
          case 34:
            {
              //众筹项目上线 OK

              mdAlert({
                title: '提示',
                content: '请复制链接在电脑端打开，在项目管理后台提交项目上线',
                actions: ['复制链接'],
                _callback: () => {
                  QuickCopy(`https://member.modian.com/project_manage/index.html`);
                }
              });
            }
            break;
          case 29:
          case 59:
            {
              // 小红书种草
              if (env.isMobile()) {
                showRedNoteUpdateGuide.value = true;
              } else {
                //PC直接跳转
                window.location.href = 'https://member.modian.com/operate_manage/task';
              }
            }
            break;
          case 31:
            {
              //专属宝箱
            }
            break;
          case 47:
            {
              goToKF();
            }
            break;
          case 52:
          case 48:
            {
              // 兑换一次推广服务
              handlePromotionAction();
            }
            break;
          case 49:
            {
              // 了解如何发起众筹
              const {
                status
              } = await videoStyduSuccess({
                pro_id: 0,
                task_id: 49
              });
              if (status == 0) {
                // eslint-disable-next-line no-undef
                graft.app({
                  functionName: "openController",
                  functionParams: `${domain.wap}/guide/operation`,
                  webFun: () => {
                    router.push({
                      path: `/guide/operation`
                    });
                  }
                });
              }
            }
            break;
          case 54:
            {
              const {
                status
              } = await videoStyduSuccess({
                pro_id: pro_id,
                task_id: 54
              });
              if (status == 0) {
                router.push({
                  path: `/project/honor`,
                  query: {
                    'pro_id': pro_id
                  }
                });
              }
            }
            break;
          case 55:
            // 使用商家推广工具
            state.showThreeChoseOne = true;
            break;
          case 64:
            {
              // 浏览初音未来二创活动
              const {
                status
              } = await videoStyduSuccess({
                pro_id: 0,
                task_id: item.task_id
              });
              if (status == 0) {
                // eslint-disable-next-line no-undef
                graft.app({
                  functionName: "openController",
                  functionParams: "https://m.modian.com/ip/webActivity/875",
                  webFun: () => {
                    location.href = 'https://m.modian.com/ip/webActivity/875';
                  }
                });
              }
              break;
            }
          default:
            mdAlert({
              title: '提示',
              content: '请去PC端项目管理后台操作项目',
              actions: ['好的']
            });
            break;
        }
      } else {
        //已完成
      }
    }

    // 推广服务
    function handlePromotionAction() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/promotion/index`,
        webFun: () => {
          router.push({
            path: `/score/promotion/index`
          });
        }
      });
    }

    // 金币明细
    function handleGoldList() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/gold/list`,
        webFun: () => {
          router.push({
            path: `/score/gold/list`
          });
        }
      });
    }

    //规则说明
    function handleTaskRule() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/task/rule`,
        webFun: () => {
          router.push({
            path: `/score/task/rule`
          });
        }
      });
    }
    // 去报名活动
    function handleGoScoreAction() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/create_score`,
        webFun: () => {
          router.push({
            path: `/score/create_score`
          });
        }
      });
    }
    // 去查看项目管理
    function handleGoProManageAction() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `md://createProList`,
        webFun: () => {
          mdAlert({
            title: '提示',
            content: '请去PC端项目管理后台操作项目',
            actions: ['好的']
          });
        }
      });
    }
    // 查看tips
    function handleTipsAction(item) {
      mdAlert({
        title: '提示',
        content: item.tips,
        actions: ['确定'],
        _callback: () => {}
      });
    }

    // 更新提示弹窗-复制链接
    function guideToPCUpdateAction(result) {
      showUpdateGuide.value = false;
      CopyContent(result.event, `https://member.modian.com/project_manage/update/index/${result.pro_id}.html`);
    }
    function guideToPCRedNoteUpdateAction(result) {
      showRedNoteUpdateGuide.value = false;
      if (env.isMobile()) {
        QuickCopy(`https://member.modian.com/project_manage/update/index/${result.pro_id}.html`);
      } else {
        //PC直接跳转
        window.location.href = 'https://member.modian.com/operate_manage/task';
      }
    }

    //离开页面
    function handleGoBack() {
      GoBack();
    }

    //是否吸顶
    function handleStickyAction(is_fix) {
      isFix.value = is_fix ? 1 : 0;
    }

    // 添加客服
    function goToKF() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `md://mini_program?name=gh_7210ac3f1f08&path=pages/index/index?nextUrl=pages/webviewPages/content/content&url=https://m.modian.com/ip/webActivity/779`,
        webFun: () => {
          if (env.isWxApp()) {
            // eslint-disable-next-line no-undef
            wx.miniProgram.navigateTo({
              url: '/pages/webviewPages/content/content?url=https://m.modian.com/ip/webActivity/779'
            });
          } else {
            getWXSchemeUrl();
          }
        }
      });
    }

    // 获取微信 Scheme URL
    async function getWXSchemeUrl() {
      const param = {
        path: "/pages/index/index",
        query: `nextUrl=pages/webviewPages/content/content&url=https://m.modian.com/ip/webActivity/779`
      };
      const option = {
        jump_wxa: JSON.stringify(param)
      };
      const url = await getSchemeUrl(option);
      location.href = url;
    }

    // 处理 tab 切换
    function handleTabSwitch() {
      // 切换状态
      state.showActivityList = !state.showActivityList;

      // 根据切换后的状态请求对应的接口
      if (state.showActivityList) {
        // 显示限时活动列表，请求活动任务
        requestActivityTaskList();
      } else {
        // 显示常规任务列表，请求常规任务
        requestTaskList();
      }
    }
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_sticky = _resolveComponent("van-sticky");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_merchantReceiveSuccess = _resolveComponent("merchantReceiveSuccess");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [!_unref(env).isWeixin() ? (_openBlock(), _createBlock(_component_van_sticky, {
        key: 0,
        onChange: handleStickyAction
      }, {
        default: _withCtx(() => [_createElementVNode("header", {
          class: _normalizeClass([{
            'headerAndroid': _unref(env).isModianAndroid()
          }, {
            'isFix': isFix.value
          }])
        }, [_createVNode(_component_van_image, {
          class: "back-btn",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score/task_back_icon.png', 40),
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleGoBack(), ["stop"]))
        }, null, 8, ["src"]), _hoisted_2, _createElementVNode("div", {
          class: "rule-info",
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => handleTaskRule(), ["stop"]))
        }, [_createVNode(_component_van_image, {
          class: "icon",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score/task_rule_icon.png', 32)
        }, null, 8, ["src"]), _hoisted_3])], 2)]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_4)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "task_go_btn",
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => handlePromotionAction(), ["stop"]))
      }), _createElementVNode("div", {
        class: "score_title",
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => handleGoldList(), ["stop"]))
      }, _hoisted_9), _createElementVNode("div", _hoisted_10, _toDisplayString(goldNum.value), 1), activityGoldNum.value > 0 || activity_coin_balance_expired_date.value && activity_coin_balance_expired_date.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [activityGoldNum.value > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, "活动金币" + _toDisplayString(activityGoldNum.value) + "金币", 1)) : _createCommentVNode("", true), activity_coin_balance_expired_date.value && activity_coin_balance_expired_date.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_Transition, {
        name: "slide"
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock("p", {
          key: currentExpiredIndex.value,
          class: "expired"
        }, _toDisplayString(activity_coin_balance_expired_date.value[currentExpiredIndex.value].expired_desc), 1))]),
        _: 1
      })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: _normalizeClass(['task_content_list', {
          'tab left': activity_task_list.value.length && _unref(state).showActivityList
        }, {
          'tab right': activity_task_list.value.length && !_unref(state).showActivityList
        }])
      }, [activity_task_list.value.length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "tab_click_area",
        onClick: _withModifiers(handleTabSwitch, ["stop"])
      }, null, 8, _hoisted_14)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [!activity_task_list.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_16)) : _createCommentVNode("", true), activity_task_list.value.length && _unref(state).showActivityList ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20)) : _createCommentVNode("", true), activity_task_list.value.length && _unref(state).showActivityList ? (_openBlock(), _createElementBlock("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity_task_list.value, (tItem, tIndex) => {
        return _openBlock(), _createElementBlock("div", {
          key: tIndex,
          class: _normalizeClass(['activity_item', `type${tItem.task_type}`])
        }, [tItem.task_type == 3 ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(tItem.task_list, (aItem, aIndex) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: aIndex
          }, [_createElementVNode("div", _hoisted_22, [_createElementVNode("p", _hoisted_23, _toDisplayString(aItem.prize), 1)]), _hoisted_24, _createElementVNode("div", {
            class: _normalizeClass(['bottom_btn', {
              'disabled': aItem.task_status == 20
            }]),
            onClick: _withModifiers($event => handleTaskAction($event, '', aItem), ["stop"])
          }, _toDisplayString(aItem.task_status == 10 ? '领取' : aItem.button_name), 11, _hoisted_25)], 64);
        }), 128)) : _createCommentVNode("", true), [1, 2].includes(tItem.task_type) ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(tItem.task_list, (aItem, aIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: aIndex,
            class: "normal_item"
          }, [_createElementVNode("div", _hoisted_26, [_createElementVNode("p", null, _toDisplayString(aItem.task_name), 1), _createElementVNode("div", _hoisted_27, [_createElementVNode("p", _hoisted_28, _toDisplayString(aItem.prize), 1)])]), _createElementVNode("div", {
            class: _normalizeClass(['right_btn', {
              'disabled': aItem.task_status == 20
            }]),
            onClick: _withModifiers($event => handleTaskAction($event, '', aItem), ["stop"])
          }, _toDisplayString(aItem.task_status == 10 ? '领取' : aItem.button_name), 11, _hoisted_29)]);
        }), 128)) : _createCommentVNode("", true), tItem.task_type == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tItem.task_list, (aItem, aIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: aIndex,
            class: "item"
          }, [_createElementVNode("div", {
            class: _normalizeClass(["step_icon", [{
              'completed': aItem.task_status == 20
            }, {
              'show': shouldShowStepIcon(tItem.task_list, aIndex)
            }]])
          }, _toDisplayString(aItem.button_name), 3), _createElementVNode("div", _hoisted_31, [_createElementVNode("p", _hoisted_32, _toDisplayString(aItem.prize), 1)]), _createElementVNode("div", {
            class: _normalizeClass(["step_name", getStepStatusClass(aItem, tItem.task_list, aIndex)])
          }, _toDisplayString(aItem.task_name), 3)]);
        }), 128))])) : _createCommentVNode("", true), tItem.task_type == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_37)) : _createCommentVNode("", true), [1, 2, 4, 5].includes(tItem.task_type) ? (_openBlock(), _createElementBlock("div", _hoisted_38, [tItem.task_type == 4 ? (_openBlock(), _createElementBlock("p", _hoisted_39, [_hoisted_40, _createElementVNode("span", _hoisted_41, _toDisplayString(tItem.max_prize), 1), _hoisted_42])) : tItem.task_type == 5 ? (_openBlock(), _createElementBlock("p", _hoisted_43, [_hoisted_44, _createElementVNode("span", _hoisted_45, _toDisplayString(tItem.max_prize), 1), _hoisted_46])) : (_openBlock(), _createElementBlock("p", _hoisted_47, [_hoisted_48, _createElementVNode("span", _hoisted_49, _toDisplayString(tItem.max_prize), 1), _hoisted_50]))])) : _createCommentVNode("", true), _hoisted_51, tItem.task_type == 4 ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "right_btn goProManage",
          onClick: _withModifiers(handleGoProManageAction, ["stop"])
        }, "去查看", 8, _hoisted_52)) : _createCommentVNode("", true), tItem.task_type == 5 ? (_openBlock(), _createElementBlock("div", {
          key: 6,
          class: "right_btn goProManage",
          onClick: _withModifiers(handleGoScoreAction, ["stop"])
        }, "去报名", 8, _hoisted_53)) : _createCommentVNode("", true)], 2);
      }), 128))])) : _createCommentVNode("", true), !activity_task_list.value.length || activity_task_list.value.length && !_unref(state).showActivityList ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 3
      }, [newbie_task_list.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newbie_task_list.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "normal_item"
        }, [_createElementVNode("div", _hoisted_56, [_createElementVNode("p", null, _toDisplayString(item.task_name), 1), _createElementVNode("div", _hoisted_57, [_createElementVNode("p", _hoisted_58, _toDisplayString(item.prize), 1)])]), _createElementVNode("div", {
          class: _normalizeClass(['right_btn', {
            'disabled': item.task_status == 20
          }]),
          onClick: _withModifiers($event => handleTaskAction($event, '', item), ["stop"])
        }, _toDisplayString(item.task_status == 10 ? '领取' : item.button_name), 11, _hoisted_59)]);
      }), 128)), _hoisted_60, _hoisted_61])])) : _createCommentVNode("", true), week_task_list.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_hoisted_64, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week_task_list.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "week_items"
        }, [_createElementVNode("div", _hoisted_65, _toDisplayString(item.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.task_list, (tItem, tIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: tIndex,
            class: "normal_item"
          }, [_createElementVNode("div", _hoisted_66, [_createElementVNode("p", null, [_createTextVNode(_toDisplayString(tItem.task_name), 1), tItem.tips ? (_openBlock(), _createBlock(_component_van_icon, {
            key: 0,
            class: "tip",
            name: "warning-o",
            onClick: _withModifiers($event => handleTipsAction(tItem), ["stop"])
          }, null, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_67, [_createElementVNode("p", _hoisted_68, "完成 (" + _toDisplayString(tItem.completed_number) + "/" + _toDisplayString(tItem.require_completed_number) + ")，", 1), _createElementVNode("p", _hoisted_69, _toDisplayString(tItem.prize), 1)])]), _createElementVNode("div", {
            class: _normalizeClass(['right_btn', {
              'disabled': tItem.task_status == 20
            }]),
            onClick: _withModifiers($event => handleTaskAction($event, item.pro_id, tItem), ["stop"])
          }, _toDisplayString(tItem.task_status == 10 ? '领取' : tItem.task_status_name), 11, _hoisted_70)]);
        }), 128))]);
      }), 128)), _hoisted_71])])) : _createCommentVNode("", true), goal_task_list.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_hoisted_74, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goal_task_list.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "goal_column"
        }, [_createElementVNode("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, _toDisplayString(item.pro_name), 1)]), _createElementVNode("div", _hoisted_77, [item.next_prize_money && item.next_prize ? (_openBlock(), _createElementBlock("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_hoisted_80, _createElementVNode("span", null, "¥" + _toDisplayString(item.next_prize_money), 1)]), _createElementVNode("div", _hoisted_81, [_hoisted_82, _createElementVNode("span", null, _toDisplayString(item.next_prize) + "金币", 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_83, [_createElementVNode("div", _hoisted_84, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_85, "¥" + _toDisplayString(item.backer_money), 1), _hoisted_86]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_87, [_createElementVNode("p", _hoisted_88, _toDisplayString(item.total_prize), 1)]), _hoisted_89])]), _createElementVNode("div", _hoisted_90, [_createElementVNode("p", null, "众筹目标¥" + _toDisplayString(item.goal), 1), _createElementVNode("p", null, "奖励 " + _toDisplayString(item.goal_prize) + "金币", 1)])])])]);
      }), 128)), _hoisted_91])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])], 2)])]), showUpdateGuide.value ? (_openBlock(), _createBlock(updateGuide, {
        key: 0,
        show: showUpdateGuide.value,
        "onUpdate:show": _cache[4] || (_cache[4] = $event => showUpdateGuide.value = $event),
        pro_id: showUpdateProID.value,
        task_id: showUpdateTaskID.value,
        onGuideToPCUpdateAction: guideToPCUpdateAction
      }, null, 8, ["show", "pro_id", "task_id"])) : _createCommentVNode("", true), showMerchantReceiveSuccess.value ? (_openBlock(), _createBlock(_component_merchantReceiveSuccess, {
        key: 1,
        show: showMerchantReceiveSuccess.value,
        "onUpdate:show": _cache[5] || (_cache[5] = $event => showMerchantReceiveSuccess.value = $event)
      }, null, 8, ["show"])) : _createCommentVNode("", true), showRedNoteUpdateGuide.value ? (_openBlock(), _createBlock(redNoteUpdateGuide, {
        key: 2,
        show: showRedNoteUpdateGuide.value,
        "onUpdate:show": _cache[6] || (_cache[6] = $event => showRedNoteUpdateGuide.value = $event),
        onGuideToPCUpdateAction: guideToPCRedNoteUpdateAction
      }, null, 8, ["show"])) : _createCommentVNode("", true), _unref(state).showThreeChoseOne ? (_openBlock(), _createBlock(threeChoseOne, {
        key: 3,
        show: _unref(state).showThreeChoseOne,
        "onUpdate:show": _cache[7] || (_cache[7] = $event => _unref(state).showThreeChoseOne = $event)
      }, null, 8, ["show"])) : _createCommentVNode("", true)], 64);
    };
  }
};